// aes_util.js
const CryptoJS = require('./aes'); //引用AES源码js
const aesKey = "yorirdkv8s5ur408";
const iv = "8cxpqs2p9uknecsh";
const appId = "142409fsaje2109jslak";
/*
 * aes 加密
 */
function encryptData(user) {
  const req = {
    programAppid: appId,
    openid: user.openid,
    userName: user.userName,
    phone: user.phone,
    medicalCardNum: user.medicalCardNum,
    age: user.age,
    gender: user.gender,
    timestamp: new Date().getTime(),
    firstVisit: true
  };
  const json = JSON.stringify(req, null, 2);
  console.log("原始JSON：" + json);
  // AES加密 (CBC模式, PKCS5Padding)

  const encrypted = CryptoJS.AES.encrypt(json,
    CryptoJS.enc.Utf8.parse(aesKey), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  const encode = encrypted.toString();
  console.log("加密字符串：" + encode);
  const urlEncoded = encodeURIComponent(encode);
  console.log("URL编码后字符串：" + urlEncoded);

  return {
    json,
    encode,
    urlEncoded
  };
}

//暴露接口
export {
  encryptData
}



// WEBPACK FOOTER //
// ./src/js/encrypt.js